import React from "react"
import { RouteObject, Outlet } from "react-router"
import { routeNames } from "src/router/route-names"
import Providers from "src/router/providers"

export const createRoutes = (): RouteObject[] => {
  return [
    {
      element: (
        <Providers>
          <Outlet />
        </Providers>
      ),
      children: [
        {
          // Adding the /* fixes an edge case if a user goes directly to /terms/index.html
          path: routeNames.termsOfService.route,
          lazy: () => import("src/pages/tos/terms-of-service"),
          children: [
            {
              path: "*",
              lazy: () => import("src/pages/tos/terms-of-service"),
            },
          ],
        },
        {
          // Adding the /* fixes an edge case if a user goes directly to /privacy/index.html
          path: routeNames.privacyNotice.route,
          lazy: () => import("src/pages/pn/privacy-notice"),
          children: [
            {
              path: "*",
              lazy: () => import("src/pages/pn/privacy-notice"),
            },
          ],
        },
      ],
      HydrateFallback: () => null,
    },
  ]
}
